import { gql } from '@apollo/client'

export const MARK_AS_READ = gql`
    mutation MarkNotificationAsRead($input: markAsReadInput!) {
        markAsRead(input: $input) {
            success
            notification {
                id
                isUnread
            }
        }
    }
`
